import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  SearchChatUsers200,
  SearchChatUsersParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Search users available for chat
 */
export const searchChatUsers = (
    params: SearchChatUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchChatUsers200>(
      {url: `https://api.ugot.uk/api/chat/users/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchChatUsersQueryKey = (params: SearchChatUsersParams,) => {
    return [`https://api.ugot.uk/api/chat/users/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchChatUsersInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof searchChatUsers>>, TError = void>(params: SearchChatUsersParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchChatUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchChatUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchChatUsers>>> = ({ signal }) => searchChatUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchChatUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchChatUsersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchChatUsers>>>
export type SearchChatUsersInfiniteQueryError = void

/**
 * @summary Search users available for chat
 */
export const useSearchChatUsersInfinite = <TData = Awaited<ReturnType<typeof searchChatUsers>>, TError = void>(
 params: SearchChatUsersParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchChatUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchChatUsersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSearchChatUsersQueryOptions = <TData = Awaited<ReturnType<typeof searchChatUsers>>, TError = void>(params: SearchChatUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchChatUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchChatUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchChatUsers>>> = ({ signal }) => searchChatUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchChatUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchChatUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchChatUsers>>>
export type SearchChatUsersQueryError = void

/**
 * @summary Search users available for chat
 */
export const useSearchChatUsers = <TData = Awaited<ReturnType<typeof searchChatUsers>>, TError = void>(
 params: SearchChatUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchChatUsers>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchChatUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



